import React from 'react';
import cn from 'classnames';

import LogoIcon from '../../../assets/icons/common/LogoIcon';

import styles from './styles.module.scss';

const ActivationBox = ({ className, notCentered, children }) => {
  return (
    <div className={styles.page}>
      <LogoIcon
        className={cn({
          [styles.mainLogo]: true,
          [styles.notCentered]: notCentered,
        })}
      />
      <main className={cn(styles.main, className)}>{children}</main>
    </div>
  );
};

export default ActivationBox;
